angular.module('autoremind.account.service')
    .factory('userSettings', ['$rootScope', 'localStorageService', 'accountService', function ($rootScope, localStorageService, accountService) {
        var service;
        service = {
            model: {
                selectedProviders: [{
                        providerId: null /**  all providers by default */
                    }],
                selectedLocations: [{
                        id: null /** all locations by default */
                    }],
                selectedFilter: [],
                hideSidebar: true,
                lineWrapping: false,
                userStatusesSelected: [{
                        "id": "Active",
                        "name": "Active"
                    }, {
                        "id": "Trial",
                        "name": "Trial"
                    }],
                userSchedulerStatusesSelected: [{
                        id: 'Trial',
                        type: 'user'
                    }, {
                        id: 'Active',
                        type: 'user'
                    }, {
                        id: "active",
                        type: "scheduler"
                    }],
                satelliteSchedulerStateSelected: [{
                        id: 'Trial',
                        type: 'user'
                    }, {
                        id: 'Active',
                        type: 'user'
                    }, {
                        id: "active",
                        type: "scheduler"
                    }],
                ar3filters: {
                    offset: 0,
                    sortby: 'templateDisplayName',
                    order: false,
                    category: 'reminder',
                    name: '',
                    file: '',
                    displayDefault: true,
                    hideOtherUsersTemplates: false,
                    hideAssignedTemplates: false,
                    hideNotMappedForCurrent: false,
                    hideLinkedAnyUsers: false,
                    language: 'en-us'
                },
                ar2filters: {
                    offset: 0,
                    sortby: 'displayName',
                    order: false,
                    type: 'all',
                    language: 'us-en',
                    displayName: '',
                    fileName: '',
                    hideOtherUsersTemplates: true,
                    hideAssignedTemplates: false,
                    hideDefault: false,
                    hideNotInDefault: false,
                    hideV09: true
                }
            },
            defaultModel: {},
            saveModel: function () {
                localStorageService.add(accountService.currentUser.username + '_settings', JSON.stringify(this.model));
            },
            loadSettingsForUser: function () {
                if (!accountService.currentUser) {
                    return;
                }
                this.model = angular.copy(this.defaultModel);
                var settings = localStorageService.get(accountService.currentUser.username + '_settings') ? JSON.parse(localStorageService.get(accountService.currentUser.username + '_settings')) : null;
                if (settings) {
                    angular.extend(this.model, settings);
                }
                // TODO: Consider moving to sidebar component and trigger init on an event for loading settings
                if (this.model.hideSidebar === undefined) {
                    // Initial default is to show if admin
                    if (accountService.hasUserPermission('admin')) {
                        this.model.hideSidebar = false;
                    }
                    else {
                        this.model.hideSidebar = true;
                    }
                }
                // Always hide sidebar for normal users (since main content margin depends on this setting)
                if (!accountService.hasUserPermission('admin')) {
                    this.model.hideSidebar = true;
                }
            },
            clearModel: function () {
                localStorageService.remove(accountService.currentUser.username + '_settings');
            },
            _construct: function () {
                this.defaultModel = angular.copy(this.model);
                this.loadSettingsForUser();
            }
        };
        service._construct();
        $rootScope.$watch(function () {
            return service.model;
        }, function (newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            service.saveModel();
        }, true);
        $rootScope.$watch(function () {
            return (accountService.currentUser ? accountService.currentUser.username : undefined) && accountService.isLoggedIn;
        }, function (newVal, oldVal) {
            if (!newVal)
                return;
            service.loadSettingsForUser();
        });
        return service;
    }]);
//# sourceMappingURL=user-settings.service.js.map